import { MiningAlternativeTypes } from "../types/mining/MiningAlternativeTypes";
import { responseHero } from "../utils/axiosInterceptor";

export const getMiningAlternative = () : Promise<MiningAlternativeTypes> => {
    return new Promise<MiningAlternativeTypes>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/mining/alternative`).then((response) => {
            resolve(response.data as MiningAlternativeTypes);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};